import React from "react";
import { DefaultLayout, Grid } from "@client/shared/components";
import { noop } from "@client/shared/constants";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { globalStyles } from "@client/shared/constants";
import style from "./style";

const UsersView = ({
  entries = [],
  entriesCount = 0,
  columnConfig = [],
  pageNumber = 1,
  pageSize = 5,
  order = null,
  orderBy = "",
  isLoading = false,
  handlePageNumberChange = noop,
  handlePageSizeChange = noop,
  handleSortChange = noop,
  handleSelectionChange = noop,
  handleGridReady = noop,
}) => {
  return (
    <Paper elevation={0}>
      <Grid
        hasPagination
        rows={entries}
        totalRows={entriesCount}
        pageNumber={pageNumber}
        pageSize={pageSize}
        order={order}
        orderBy={orderBy}
        columns={columnConfig}
        isLoading={isLoading}
        onPageNumberChange={handlePageNumberChange}
        onPageSizeChange={handlePageSizeChange}
        onSortChange={handleSortChange}
        onSelectionChange={handleSelectionChange}
        onReady={handleGridReady}
        classes={{
          container: style.tableContainer,
        }}
        entriesText="Users"
      />
    </Paper>
  );
};

export default UsersView;
